
@if (config.url != undefined) {
  <iframe
    frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%; height:2000px;"
    [src]="config.url | safeResourceHtml">
  </iframe>
}
